/** Stable per-tab identifier for local AVE ownership. Survives re-renders but is unique per tab.
 * Context: Local AVEs only support one simultaneous connection - this would cause issues if multiple tabs
 * are connected to the same 3DE session (e.g. when DCC with 3DE web components is opened via the 3DE
 * standalone). Using this identifier allows us to prevent multiple tabs from connecting to the same local AVE.
 */
export const localAveTabId = `avp-3dexhibition-${crypto.randomUUID()}`;
